module.exports = __webpack_public_path__ + "static/10-db3e60f76bc7cc954d6b8c07b3741fcb.jpg";